import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import VideoPlayersWithType from 'pages/builder/video_clips/video_players_with_type';
import { VideoClipStore } from '@seedlang/stores';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import autobind from 'autobind-decorator';
import CheckIfTrue from 'components/check_if_true';
import Grid from 'components/layout/grid';
import GrayButton from 'components/button/gray_button';

@observer
class VideoClipEdit extends React.Component {

  constructor(props) {
    super(props);
    this.getVideoClip();
  }

  @autobind getVideoClip() {
    VideoClipStore.getShow({ids: {videoClipId: this.props.params.videoClipId}});
  }

  @autobind update(data) {
    VideoClipStore.update({ids: {videoClipId: this.props.params.videoClipId}, data: data}, this.getVideoClip);
  }

  render() {
    return (
      <Grid columns={3} gap='sm'>
        <fieldset>
          <legend>Video Clip</legend>
          <VideoPlayersWithType
            videoClip={VideoClipStore.showData}
            width='150px'
          />
        </fieldset>
        <fieldset>
          <legend>Translation</legend>
          {VideoClipStore.showData.videoable && VideoClipStore.showData.videoable.text}
          {VideoClipStore.showData.cleared && ' (Cleared)'}
        </fieldset>
        <fieldset>
          <legend>Size</legend>
          {VideoClipStore.showData.formattedFileSize}
        </fieldset>
        <fieldset>
          <legend>Normalized Audio</legend>
          <CheckIfTrue
            value={VideoClipStore.showData.audioIsNormalized}
          />
          {
            VideoClipStore.showData.audioIsNormalized &&
              <GrayButton
                onClick={() => this.update({audio_is_normalized: false})}
              >
                Restore Source Audio
              </GrayButton>
          }
          {
            !VideoClipStore.showData.audioIsNormalized &&
              <GrayButton
                onClick={() => this.update({audio_is_normalized: true})}
              >
                Normalize Audio
              </GrayButton>
          }
        </fieldset>
        <fieldset>
          <legend>Replace</legend>
          {
            VideoClipStore.showData && VideoClipStore.showData.videoable &&
              <InPlaceCheckbox
                model='targets'
                field='replace_video'
                id={VideoClipStore.showData.videoable.id}
                value={VideoClipStore.showData.videoable.replaceVideo}
                afterChange={this.props.afterChange}
              />
          }
        </fieldset>
        <fieldset>
          <legend>Loading Info</legend>
          <div>Average Load (Android): {VideoClipStore.showData.averageLoadTimeAndroid}</div>
          <div>Average Load (iOS): {VideoClipStore.showData.averageLoadTimeIos}</div>
          <div>Timed Out (Android): {VideoClipStore.showData.numberTimedOutAndroid}</div>
          <div>Timed Out (iOS): {VideoClipStore.showData.numberTimedOutIos}</div>
        </fieldset>
      </Grid>
    );
  }
}

export default ErrorBoundary(VideoClipEdit);
